const HEADINGS: Record<string, number> = {
  h1: 1,
  h2: 2,
  h3: 3,
  h4: 4,
}

const ALIGNS = ['left', 'center', 'right', 'justify']

export const escapeHtml = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

export const textToHtml = (value: string) =>
  escapeHtml(value).replace(/\n/g, '<br />')

export const wp = (type: string, html: string, attrs = '') =>
  `<!-- wp:${type}${attrs} -->${html}<!-- /wp:${type} -->`

export const align = (value?: string) =>
  value && ALIGNS.includes(value) ? value : undefined

export const htmlAttr = (name: string, value?: number | string) =>
  value ? ` ${name}="${value}"` : ''

const wpAttrs = (values: Record<string, number | string | undefined>) => {
  const items = Object.entries(values).filter(
    ([, value]) => value !== undefined
  )

  return items.length ? ` ${JSON.stringify(Object.fromEntries(items))}` : ''
}

const alignClass = (value?: string) => (value ? ` has-text-align-${value}` : '')

export const heading = (type: string, html: string, textAlign?: string) => {
  const level = HEADINGS[type]
  const normalizedAlign = align(textAlign)

  if (!level) {
    return null
  }

  const levelAttr = level === 2 ? undefined : level
  const headingAttrs = wpAttrs({
    textAlign: normalizedAlign,
    level: levelAttr,
  })

  return wp(
    'heading',
    `<h${level} class="wp-block-heading${alignClass(
      normalizedAlign
    )}">${html}</h${level}>`,
    headingAttrs
  )
}

export const paragraph = (html: string, textAlign?: string) => {
  const normalizedAlign = align(textAlign)

  return wp(
    'paragraph',
    `<p${normalizedAlign ? ` class="${alignClass(normalizedAlign).trim()}"` : ''}>${html}</p>`,
    wpAttrs({ align: normalizedAlign })
  )
}

export const quote = (html: string, textAlign?: string) => {
  const normalizedAlign = align(textAlign)

  return wp(
    'quote',
    `<blockquote class="wp-block-quote${alignClass(
      normalizedAlign
    )}"><p>${html}</p></blockquote>`,
    wpAttrs({ align: normalizedAlign })
  )
}

export const code = (text: string) =>
  wp(
    'code',
    `<pre class="wp-block-code"><code>${escapeHtml(text)}</code></pre>`
  )

export const separator = () =>
  wp('separator', '<hr class="wp-block-separator has-alpha-channel-opacity"/>')

export const table = (html: string) =>
  wp(
    'table',
    `<figure class="wp-block-table"><table class="has-fixed-layout"><tbody>${html}</tbody></table></figure>`
  )
